import { gql } from "@apollo/client";

export const DELETE_BANK_PAYMENT = gql`
  mutation deletePayment($projectId: ID!, $paymentId: ID!) {
    deletePayment(projectId: $projectId, paymentId: $paymentId) {
      ... on BankAccount {
        id
        projectId
        type
        isActive
        accountName
        accountNumber
        bankAccountType
        bankBranch
        bankName
      }
    }
  }
`;

export const SAVE_PAYMENTS = gql`
  mutation upsertPayment($projectId: ID!, $paymentInputs: [PaymentInput]!, $isUpdatePaymentToggle: Boolean) {
    savePayments: upsertPayment(
      projectId: $projectId
      paymentInputs: $paymentInputs
      isUpdatePaymentToggle: $isUpdatePaymentToggle
    ) {
      ... on BankAccount {
        id
        projectId
        type
        isActive
        accountName
        accountNumber
        bankAccountType
        bankBranch
        bankName
      }
      ... on PromptPay {
        id
        projectId
        type
        isActive
        accountName
        accountNumber
        image
      }
      ... on COD {
        id
        projectId
        type
        isActive
        shippingMethod
        depositType
        depositThreshold
        depositAmount
        managementFee {
          fee
          percent
          type
          isAppliedPromotion
        }
      }
      ... on PaymentGatewayChillPay {
        id
        projectId
        type
        isActive
        apiKey
        md5Secret
        merchantId
        description
      }
      ... on PaymentGateway2C2P {
        id
        projectId
        type
        isActive
        md5Secret
        merchantId
        description
      }
      ... on PaymentGatewayCustom {
        id
        projectId
        type
        isActive
        description
        header
        body
        iconUrl
        url
      }
    }
  }
`;
